import React, { createContext, useContext, useState } from "react";

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    companyName: "RideShare Pro",
    driverName: "John Driver",
    primaryColor: "#51cf66",
    secondaryColor: "#339af0",
    accentColor: "#f06595",
    backgroundColor: "#f8f9fa",
    headerColor: "#212529",
  });

  const updateTheme = (newTheme) => {
    setTheme((prev) => ({ ...prev, ...newTheme }));
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
